"use strict";
exports.__esModule = true;
exports.isProtoEventData = exports.isEvent = void 0;
function isEvent(item) {
    return "eventName" in item;
}
exports.isEvent = isEvent;
function isProtoEventData(item) {
    return "toProto" in item;
}
exports.isProtoEventData = isProtoEventData;
//# sourceMappingURL=event.js.map